import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ModalDrawer from './ModalDrawer.js';
import { supportedLocales } from '../i18n';
import { SUPPORTED_CURRENCIES } from '../constants';

const LocalizationModal = ({ isOpen, onClose, theme, uiPreferences }) => {
    const { t, i18n } = useTranslation();
    
    const [localLocale, setLocalLocale] = useState(i18n.language);
    const [localCurrency, setLocalCurrency] = useState(uiPreferences.currency);
    const [selectedLanguage, setSelectedLanguage] = useState(i18n.language.split('-')[0]);

    useEffect(() => {
        if (isOpen) {
            setLocalLocale(i18n.language);
            setLocalCurrency(uiPreferences.currency);
            setSelectedLanguage(i18n.language.split('-')[0]);
        }
    }, [isOpen, i18n.language, uiPreferences.currency]);
    
    const availableLocales = Object.keys(supportedLocales).filter(locale => locale.startsWith(selectedLanguage));

    const handleLanguageChange = (e) => {
        const newLang = e.target.value;
        setSelectedLanguage(newLang);
        const firstLocaleForLang = Object.keys(supportedLocales).find(locale => locale.startsWith(newLang));
        if (firstLocaleForLang) {
            setLocalLocale(firstLocaleForLang);
        }
    };

    const handleSave = () => {
        i18n.changeLanguage(localLocale);
        uiPreferences.setCurrency(localCurrency);
        onClose();
    };

    const footer = (
        <>
            <button onClick={onClose} className="btn btn-ghost">{t('general.cancel')}</button>
            <button onClick={handleSave} className="btn btn-grad">{t('general.save')}</button>
        </>
    );

    return (
        <ModalDrawer
            isOpen={isOpen}
            onClose={onClose}
            title={t('localization.modalTitle')}
            theme={theme}
            footer={footer}
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                <div className="form-group">
                    <label htmlFor="language-select" className="form-label">{t('localization.language')}</label>
                    <select id="language-select" value={selectedLanguage} onChange={handleLanguageChange} className="form-input">
                        <option value="en">{t('localization.languageName.en', 'English')}</option>
                        <option value="cs">{t('localization.languageName.cs', 'Czech')}</option>
                    </select>
                </div>
                <div className="form-group">
                    <label htmlFor="locale-select" className="form-label">{t('localization.locale')}</label>
                    <select id="locale-select" value={localLocale} onChange={(e) => setLocalLocale(e.target.value)} className="form-input">
                        {availableLocales.map(locale => (
                            <option key={locale} value={locale}>{supportedLocales[locale].label}</option>
                        ))}
                    </select>
                </div>
                <div className="form-group">
                    <label htmlFor="currency-select" className="form-label">{t('localization.currency')}</label>
                    <select id="currency-select" value={localCurrency} onChange={(e) => setLocalCurrency(e.target.value)} className="form-input">
                        {SUPPORTED_CURRENCIES.map(c => (
                            <option key={c.code} value={c.code}>{c.code} ({c.symbol})</option>
                        ))}
                    </select>
                </div>
            </div>
        </ModalDrawer>
    );
};

export default LocalizationModal;